export default {
  currentUser: null,
  loading: false,
};
